import {  Divider } from '@mantine/core';

export const SitePropertyDivider = () => {

    return (
        <Divider my="0" />
    )
}